import { render, staticRenderFns } from "./GrandVitra.vue?vue&type=template&id=61671eeb&"
import script from "./GrandVitra.vue?vue&type=script&lang=ts&"
export * from "./GrandVitra.vue?vue&type=script&lang=ts&"
import style0 from "./GrandVitra.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports